import { ChildRecord, ParentRecord } from '@/shared/api/rest/types'

/** A parent row from `GET /parents`, enriched with a resolved branch name. */
export type RegistryParent = ParentRecord & {
    email?: string | null
    branch?: { name: string } | null
}

export const getParentName = (parent: RegistryParent): string => {
    const name = [parent.firstName, parent.lastName].filter(Boolean).join(' ').trim()
    return name || parent.email?.trim() || 'Unnamed parent'
}

export const getChildName = (child: ChildRecord): string =>
    [child.firstName, child.middleName, child.lastName].filter(Boolean).join(' ').trim()
